<script src="application-form.component.ts"></script>
<div class="container-fluid">
  <ng-template #content let-modal>
    <div class="landing-modal">
      <div class="modal-header">
        <h5 class="font-weight-400" *ngIf="modalType === 'PHOTOGRAPH_MODAL'">
          <i class="fab fa-pagelines cursor-pointer mr-2"></i>
          <span>Student Photograph</span>
        </h5>
        <h5 class="font-weight-400" *ngIf="modalType === 'SIGNATURE_MODAL'">
          <i class="fab fa-pagelines cursor-pointer mr-2"></i>
          <span>Student Signature</span>
        </h5>
        <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
           (click)="this.modalService.dismissAll('')"></i>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="modalType === 'PHOTOGRAPH_MODAL'">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row" *ngIf="imageChangedEvent">
              <div class="text-center col-md-12">
                <image-cropper
                  [imageChangedEvent]="imageChangedEvent"
                  [maintainAspectRatio]="true"
                  [aspectRatio]="20 / 20"
                  [resizeToWidth]="200"
                  format="png, jpeg, jpg"
                  (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()"
                  (loadImageFailed)="loadImageFailed()">
                </image-cropper>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="text-center mt-2 mb-2">
                  <img [src]="photographImageUploadArea" class="img-fluid width-85-per cursor-pointer" alt="Image Area"
                       (click)="imageProfileUpload.click()" *ngIf="!imageChangedEvent"/>
                  <input class="form-control-file display-hidden" type="file"
                         (change)="onImageChange($event)" #imageProfileUpload>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 upper-shadow-light"
                   *ngIf="!docSubmittingPhotograph">
                <button class="btn btn-primary btn-raised mt-1 mb-1 pull-right" type="button"
                        *ngIf="imageChangedEvent" (click)="savePhotograph()">
                  <i class="fa fa-save mr-1"></i> Save
                </button>
                <button class="btn btn-danger btn-raised mr-1 mt-1 mb-1 pull-right" type="button"
                        (click)="imageProfileUpload.click()">New Upload
                </button>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 upper-shadow-light"
                   *ngIf="docSubmittingPhotograph">
                <button class="btn btn-primary btn-raised mt-1 mb-1 pull-right" type="button">
                  <i class="fas fa-spinner fa-pulse color-white mr-1"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="modalType === 'SIGNATURE_MODAL'">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row" *ngIf="signChangedEvent">
              <div class="text-center col-md-12">
                <image-cropper
                  [imageChangedEvent]="signChangedEvent"
                  [maintainAspectRatio]="true"
                  [aspectRatio]="25 / 25"
                  [resizeToWidth]="300"
                  format="png, jpeg, jpg"
                  (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()"
                  (cropperReady)="cropperReady()"
                  (loadImageFailed)="loadImageFailed()">
                </image-cropper>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="text-center mt-2 mb-2">
                  <img [src]="photographImageUploadArea" class="img-fluid width-85-per cursor-pointer" alt="Image Area"
                       (click)="imageSignUpload.click()" *ngIf="!signChangedEvent"/>
                  <input class="form-control-file display-hidden" type="file"
                         (change)="onSignChange($event)" #imageSignUpload>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 upper-shadow-light">
                <button class="btn btn-primary btn-raised mt-1 mb-1 pull-right" type="button"
                        *ngIf="signChangedEvent" (click)="saveSignature()">
                  <i class="fa fa-save mr-1"></i> Save
                </button>
                <button class="btn btn-danger btn-raised mr-1 mt-1 mb-1 pull-right" type="button"
                        (click)="imageSignUpload.click()">New Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-sm-12">
      <div class="card card-shadow">
        <div class="card-header p-25px">
          <h5>{{user?.name}} : Admission</h5><span>Student > Admission Form</span>
        </div>
        <div class="card-body">
          <aw-wizard navBarLayout='large-filled-symbols'>
            <aw-wizard-step [navigationSymbol]="{symbol: '1'}">
              <form [formGroup]="personalInfoForm">
                <ng-template awWizardStepTitle>
                  <p class="d-lg-block d-sm-none">Personal Info</p>
                </ng-template>
                <div class="setup-content mt-50" id="step-1">
                  <h5 class="d-lg-none d-sm-block text-center m-b-50">Personal Info</h5>
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="application_no">Application No.<small class="text-danger">*</small></label>
                          <input class="form-control" id="application_no" type="text" required="required"
                                 formControlName="application_no">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="session">Admission Session<small class="text-danger">*</small></label>
                          <input class="form-control" id="session" type="text" formControlName="session_id">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="admission_type">Admission Type<small class="text-danger">*</small></label>
                          <select class="form-control" id="admission_type" formControlName="admission_type"
                                  (change)="admissionType($event)">
                            <option value="">Select Admission Type</option>
                            <option value="FRESH_ADMISSION">Fresh Admission</option>
                            <option value="LATERAL_ENTRY">Lateral Entry</option>
                          </select>
                          <small *ngIf="submitted && personalInfoForm.get('admission_type').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="year">Year<small class="text-danger">*</small></label>
                          <input class="form-control" id="year" type="text" formControlName="year">
                          <small *ngIf="submitted && personalInfoForm.get('year').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="fullname">Full Name<small class="text-danger">*</small></label>
                          <input class="form-control" id="fullname" type="text" required="required"
                                 formControlName="name">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="fullname-hindi">Full Name (हिन्दी)<small class="text-danger">*</small></label>
                          <input class="form-control" id="fullname-hindi" type="text" required="required"
                                 formControlName="name_hindi">
                          <small *ngIf="submitted && personalInfoForm.get('name_hindi').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="email">Email<small class="text-danger">*</small></label>
                          <input class="form-control" id="email" type="text" formControlName="email">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="contact-name">Contact Number<small class="text-danger">*</small></label>
                          <input class="form-control" id="contact-name" type="number" formControlName="contact">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="father-name">Father's Name<small class="text-danger">*</small></label>
                          <input class="form-control" id="father-name" type="text" formControlName="father_name"
                                 (change)="getHindiName('FATHER', $event)">
                          <small *ngIf="submitted && personalInfoForm.get('father_name').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="father-name-hindi">Father's Name (हिन्दी)<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="father-name-hindi" type="text"
                                 formControlName="father_name_hindi">
                          <small *ngIf="submitted && personalInfoForm.get('father_name_hindi').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="mother-name">Mother's Name<small class="text-danger">*</small></label>
                          <input class="form-control" id="mother-name" type="text" formControlName="mother_name"
                                 (change)="getHindiName('MOTHER', $event)">
                          <small *ngIf="submitted && personalInfoForm.get('mother_name').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="mother-name-hindi">Mother's Name (हिन्दी)<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="mother-name-hindi" type="text"
                                 formControlName="mother_name_hindi">
                          <small *ngIf="submitted && personalInfoForm.get('mother_name_hindi').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="date-of-birth">Date Of Birth<small class="text-danger">*</small></label>
                          <input class="form-control" id="date-of-birth" type="date" formControlName="dob"/>
                          <small *ngIf="submitted && personalInfoForm.get('dob').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="gender">Gender<small
                            class="text-danger">*</small></label>
                          <select class="form-control" id="gender" formControlName="gender">
                            <option value="">Select Gender</option>
                            <option value="MALE">Male</option>
                            <option value="FEMALE">Female</option>
                            <option value="OTHER">Other</option>
                          </select>
                          <small *ngIf="submitted && personalInfoForm.get('gender').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="abc_id_no">DEB Id </label>
                          <input class="form-control" id="deb_unique_id" type="text"
                                 formControlName="deb_unique_id" placeholder="Enter DEB Id"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="abc_id_no">ABC (Academic Bank Credit) Id No.</label>
                          <input class="form-control" id="abc_id_no" type="text"
                                 formControlName="abc_id_no" placeholder="Enter ABC Id No."/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="govt_photo_id_no">Govt. Photo Id No.<small class="text-danger">*</small></label>
                          <input class="form-control" id="govt_photo_id_no" type="text"
                                 formControlName="govt_photo_id_no"/>
                          <small *ngIf="submitted && personalInfoForm.get('govt_photo_id_no').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                          <small
                            *ngIf="submitted && personalInfoForm && personalInfoForm.controls && personalInfoForm.controls['govt_photo_id_no'] && personalInfoForm.controls['govt_photo_id_no'].errors && personalInfoForm.controls['govt_photo_id_no'].errors.pattern"
                            class="text-danger">Invalid Aadhar card number.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label >Select Document Type<small class="text-danger">*</small></label>
                          <select class="form-control" formControlName="government_id_type"  (change)="onDocumentTypeChange($event.target.value)">
                            <option value="">Select Government Id Type</option>
                            <option value="AADHAR_CARD">Aadhar Card</option>
                            <option value="VOTOR_ID">voter id </option>
                            <option value="PAN_CARD">Pan Card</option>
                            <option value="DRIVING_LICENCE">Driving Licence</option>
                            <option value="OTHERS_GOVERNMENT_ID">Others</option>
                          </select>
                          <small *ngIf="submitted && personalInfoForm.get('government_id_type').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'AADHAR_CARD'">
                        <div class="form-group">
                          <label for="aadhar-id-front">Upload Your Aadhar Front Image</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="aadhar-id-front"
                                      (click)="fileUploadAadharFront.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'AADHAR_FRONT')"
                                     #fileUploadAadharFront>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileAadharFrontSide && fileAadharFrontSide.id && fileAadharFrontSide.url"
                                    (click)="goTo(fileAadharFrontSide.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary" ><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'AADHAR_FRONT')"
                                     #fileUploadAadharFront>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileAadharFrontSide && fileAadharFrontSide.id && fileAadharFrontSide.url"
                                    (click)="goTo(fileAadharFrontSide.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'AADHAR_CARD'">
                        <div class="form-group">
                          <label for="aadhar-id-back">Upload Your Aadhar Back Image</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="aadhar-id-back"
                                      (click)="fileUploadAadharBack.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'AADHAR_BACK')"
                                     #fileUploadAadharBack>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileAadharBackSide && fileAadharBackSide.id && fileAadharBackSide.url"
                                    (click)="goTo(fileAadharBackSide.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary" ><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'AADHAR_BACK')"
                                     #fileUploadAadharBack>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileAadharBackSide && fileAadharBackSide.id && fileAadharBackSide.url"
                                    (click)="goTo(fileAadharBackSide.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'VOTOR_ID'">
                        <div class="form-group">
                          <label for="votor-id">Upload Your Voter Id</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="votor-id"
                                      (click)="fileUploadVoterId.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'VOTER_ID')"
                                     #fileUploadVoterId>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileVoterId && fileVoterId.id && fileVoterId.url"
                                    (click)="goTo(fileVoterId.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary" ><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'VOTER_ID')"
                                     #fileUploadVoterId>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileVoterId && fileVoterId.id && fileVoterId.url"
                                    (click)="goTo(fileVoterId.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'PAN_CARD'">
                        <div class="form-group">
                          <label for="pan-card">Upload Your Pan Card</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="pan-card"
                                      (click)="fileUploadPancard.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'PAN_CARD')"
                                     #fileUploadPancard>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePanCard && filePanCard.id && filePanCard.url"
                                    (click)="goTo(filePanCard.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary" ><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'PAN_CARD')"
                                     #fileUploadPancard>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePanCard && filePanCard.id && filePanCard.url"
                                    (click)="goTo(filePanCard.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'DRIVING_LICENCE'">
                        <div class="form-group">
                          <label for="driving-licence">Upload Your Driving Licence</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="driving-licence"
                                      (click)="fileUploaDrivingLicence.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'DRIVING_LICENCE')"
                                     #fileUploaDrivingLicence>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileDrivingLicence && fileDrivingLicence.id && fileDrivingLicence.url"
                                    (click)="goTo(fileDrivingLicence.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary" ><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'DRIVING_LICENCE')"
                                     #fileUploaDrivingLicence>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileDrivingLicence && fileDrivingLicence.id && fileDrivingLicence.url"
                                    (click)="goTo(fileDrivingLicence.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="selectedDocumentType === 'OTHERS_GOVERNMENT_ID'">
                        <div class="form-group">
                          <label for="other-documents">Upload Your Other  Govt. Photo Id</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="other-documents"
                                      (click)="fileUploadOtherGovtPhotoId.click()"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'OTHERS_GOVERNMENT_ID')"
                                     #fileUploadOtherGovtPhotoId>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileOtherGovermentID && fileOtherGovermentID.id && fileOtherGovermentID.url"
                                    (click)="goTo(fileOtherGovermentID.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-secondary"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'OTHERS_GOVERNMENT_ID')"
                                     #fileUploadOtherGovtPhotoId>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileOtherGovermentID && fileOtherGovermentID.id && fileOtherGovermentID.url"
                                    (click)="goTo(fileOtherGovermentID.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="govt-photo-id">Upload Your Aadhar Photo</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class=" btn btn-primary" id="govt-photo-id"
                                      (click)="fileUploadGovtPhotoId.click()"
                                      *ngIf="!docSubmittingGovtPhotoId"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <button class=" btn btn-primary" *ngIf="docSubmittingGovtPhotoId">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i> Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'GOVT_PHOTO_ID')"
                                     #fileUploadGovtPhotoId>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileGovtPhotoId && fileGovtPhotoId.id && fileGovtPhotoId.url"
                                    (click)="goTo(fileGovtPhotoId.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileGovtPhotoId && fileGovtPhotoId.id && fileGovtPhotoId.url"
                                    (click)="goTo(fileGovtPhotoId.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>-->
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="photograph">Upload Your Photograph </label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="photograph" (click)="openImageUploadModal(content)">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePhotograph && filePhotograph.id && filePhotograph.url"
                                    (click)="goTo(filePhotograph.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePhotograph && filePhotograph.id && filePhotograph.url"
                                    (click)="goTo(filePhotograph.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="signature">Upload Your Signature </label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="signature" (click)="openSignatureUploadModal(content)">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileSignature && fileSignature.id && fileSignature.url"
                                    (click)="goTo(fileSignature.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary" >
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileSignature && fileSignature.id && fileSignature.url"
                                    (click)="goTo(fileSignature.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary pull-right mt-50" type="submit" (click)="submitPersonalInfo()"
                        *ngIf="!submittedForm">
                  Save & Next
                </button>
                <button class="btn btn-primary pull-right mt-50" type="submit" (click)="wizard.goToNextStep()"
                        *ngIf="submittedForm">
                  Next
                </button>
              </form>
            </aw-wizard-step>
            <aw-wizard-step [navigationSymbol]="{symbol: '2'}">
              <form [formGroup]="addressForm">
                <ng-template awWizardStepTitle>
                  <p class="d-lg-block d-sm-none">Address</p>
                </ng-template>
                <div class="setup-content mt-50" id="step-2">
                  <h5 class="d-lg-none d-sm-block text-center m-b-50">Address</h5>
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                          <label for="address">Address<small class="text-danger">*</small></label>
                          <textarea class="form-control resize-none" id="address" rows="5"
                                    formControlName="address"></textarea>
                          <small *ngIf="submitted && addressForm.get('address').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="country_id">Country<small class="text-danger">*</small></label>
                          <select class="form-control" id="country_id" formControlName="country_id">
                            <option value="">Select Country</option>
                            <option [value]="coun.id" *ngFor="let coun of country">{{coun?.name}}</option>
                          </select>
                          <small *ngIf="submitted && addressForm.get('country_id').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="state_id">State<small class="text-danger">*</small></label>
                          <select class="form-control" id="state_id" formControlName="state_id">
                            <option value="">Select State</option>
                            <option [value]="state.id" *ngFor="let state of states">{{state?.name}}</option>
                          </select>
                          <small *ngIf="submitted && addressForm.get('state_id').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="city">City / Town<small class="text-danger">*</small></label>
                          <input class="form-control" id="city" type="text" formControlName="city">
                          <small *ngIf="submitted && addressForm.get('city').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="pin_code">Pin Code<small class="text-danger">*</small></label>
                          <input class="form-control" id="pin_code" type="number" formControlName="pin_code">
                          <small *ngIf="submitted && addressForm.get('pin_code').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="nationality">Nationality<small class="text-danger">*</small></label>
                          <input class="form-control" id="nationality" formControlName="nationality">
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="employment_status">Locality<small class="text-danger">*</small></label>
                          <select class="form-control" id="locality" formControlName="locality">
                            <option value="">Select Locality</option>
                            <option [value]="localityStatus?.value"
                                    *ngFor="let localityStatus of localityStatuses">{{localityStatus?.name}}</option>
                          </select>
                          <small *ngIf="submitted && addressForm.get('locality').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="category">Category<small class="text-danger">*</small></label>
                          <select class="form-control" id="category" formControlName="category">
                            <option value="">Select Category</option>
                            <option [value]="category?.value"
                                    *ngFor="let category of categories">{{category?.name}}</option>
                          </select>
                          <small *ngIf="submitted && addressForm.get('category').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="employment_status">Employment Status<small class="text-danger">*</small></label>
                          <select class="form-control" id="employment_status" formControlName="employment_status">
                            <option value="">Select Employment Status</option>
                            <option [value]="employementStatus?.value"
                                    *ngFor="let employementStatus of employmentStatuses">{{employementStatus?.name}}</option>
                          </select>
                          <small *ngIf="submitted && addressForm.get('employment_status').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary pull-right mt-10" type="submit" (click)="submitAddress()"
                        *ngIf="!submittedForm">Save & Next
                </button>
                <button class="btn btn-primary pull-right mt-10" type="submit" (click)="wizard.goToNextStep()"
                        *ngIf="submittedForm">Next
                </button>
                <button class="btn btn-secondary mt-10" type="button" awPreviousStep>Previous</button>
              </form>
            </aw-wizard-step>
            <aw-wizard-step [navigationSymbol]="{ symbol: '3' }">
              <form [formGroup]="academicDetailsForm">
                <ng-template awWizardStepTitle>
                  <p class="d-lg-block d-sm-none">Academic Details</p>
                </ng-template>
                <div class="setup-content mt-50" id="step-3">
                  <h5 class="d-lg-none d-sm-block text-center m-b-50">Academic Details</h5>
                  <div class="col-xs-12">
                    <h6>Details of Educational Qualifications - 10th Academic Details</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="tenth_board">Board<small class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="tenth_board" formControlName="tenth_board"
                                 placeholder="Eg. CBSE, ICSE etc."/>
                          <small *ngIf="submitted && academicDetailsForm.get('tenth_board').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="tenth-subjects">Subjects<small class="text-danger">*</small></label>
                          <input class="form-control" id="tenth-subjects" type="text" formControlName="tenth_subjects"
                                 placeholder="Eg. English, Hindi, Maths, Science etc."/>
                          <small *ngIf="submitted && academicDetailsForm.get('tenth_subjects').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="tenth-year-of-passing">Year of Passing<small class="text-danger">*</small></label>
                          <input class="form-control" id="tenth-year-of-passing" type="number"
                                 formControlName="tenth_year_of_passing"/>
                          <small
                            *ngIf="submitted && academicDetailsForm.get('tenth_year_of_passing').hasError('required')"
                            class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="tenth-division-grade">Percentage / Grade / Division<small class="text-danger">*</small></label>
                          <input class="form-control" id="tenth-division-grade" type="text"
                                 formControlName="tenth_division_grade"/>
                          <small
                            *ngIf="submitted && academicDetailsForm.get('tenth_division_grade').hasError('required')"
                            class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="tenth-certificate">Upload Your 10th Certificate</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="tenth-certificate"
                                      (click)="fileUploadTenthCertificate.click()"
                                      *ngIf="!docSubmittingTenthCertificate">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <button class="btn btn-primary" *ngIf="docSubmittingTenthCertificate">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i>Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'TENTH_CERTIFICATE')"
                                     #fileUploadTenthCertificate>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileTenthCertificate && fileTenthCertificate.id && fileTenthCertificate.url"
                                    (click)="goTo(fileTenthCertificate.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileTenthCertificate && fileTenthCertificate.id && fileTenthCertificate.url"
                                    (click)="goTo(fileTenthCertificate.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h6 class="mt-10">Details of Educational Qualifications - 12th Academic Details</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="twelth_board">Board<small class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="twelth_board" formControlName="twelth_board"
                                 placeholder="Eg. CBSE, ICSE etc."/>
                          <small *ngIf="submitted && academicDetailsForm.get('twelth_board').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="twelth-subjects">Subjects<small class="text-danger">*</small></label>
                          <input class="form-control" id="twelth-subjects" type="text" formControlName="twelth_subjects"
                                 placeholder="Eg. English, Hindi, Political Science, History etc."/>
                          <small *ngIf="submitted && academicDetailsForm.get('twelth_subjects').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="twelth-year-of-passing">Year of Passing<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="twelth-year-of-passing" type="number"
                                 formControlName="twelth_year_of_passing"/>
                          <small
                            *ngIf="submitted && academicDetailsForm.get('twelth_year_of_passing').hasError('required')"
                            class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="twelth-division-grade">Percentage / Grade / Division<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="twelth-division-grade" type="text"
                                 formControlName="twelth_division_grade"/>
                          <small
                            *ngIf="submitted && academicDetailsForm.get('twelth_division_grade').hasError('required')"
                            class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="twelth-certificate">Upload Your 12th Certificate </label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="twelth-certificate"
                                      (click)="fileUploadTwelthCertificate.click()"
                                      *ngIf="!docSubmittingTwelthCertificate"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <button class="btn btn-primary" *ngIf="docSubmittingTwelthCertificate">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i>Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'TWELTH_CERTIFICATE')"
                                     #fileUploadTwelthCertificate>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileTwelthCertificate && fileTwelthCertificate.id && fileTwelthCertificate.url"
                                    (click)="goTo(fileTwelthCertificate.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileTwelthCertificate && fileTwelthCertificate.id && fileTwelthCertificate.url"
                                    (click)="goTo(fileTwelthCertificate.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h6 class="mt-10">Details of Highest Qualification</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="highest_qualification">Highest Qualification<small class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="highest_qualification" formControlName="highest_qualification"
                                 placeholder="Eg. Graduation , PG"/>
                          <small *ngIf="submitted && academicDetailsForm.get('highest_qualification').hasError('required')"
                                 class="text-danger">
                            Field is required.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary pull-right mt-10" type="submit" (click)="submitAcademicDetails()"
                        *ngIf="!submittedForm">Save & Next
                </button>
                <button class="btn btn-primary pull-right mt-10" type="submit"
                        *ngIf="submittedForm" (click)="wizard.goToNextStep()">Next
                </button>
                <button class="btn btn-secondary mt-10" type="button" awPreviousStep>Previous</button>
              </form>
            </aw-wizard-step>
            <aw-wizard-step [navigationSymbol]="{ symbol: '4' }">
              <form [formGroup]="moreQualificationForm">
                <ng-template awWizardStepTitle>
                  <p class="d-lg-block d-sm-none">More Qualification</p>
                </ng-template>
                <div class="setup-content mt-50" id="step-4">
                  <h5 class="d-lg-none d-sm-block text-center m-b-50">More Qualification</h5>
                  <div class="col-xs-12">
                    <h6>More Qualification - Graduation</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="graduation_university">University<small class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="graduation_university"
                                 formControlName="graduation_university" placeholder="Eg. Subharti University"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="graduation_course">Course<small class="text-danger">*</small></label>
                          <input class="form-control" id="graduation_course" type="text"
                                 formControlName="graduation_course" placeholder="Eg. BBA"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="graduation_year_of_passing">Year of Passing<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="graduation_year_of_passing" type="number"
                                 formControlName="graduation_year_of_passing"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="graduation_division_grade">Percentage / Grade / Division<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="graduation_division_grade" type="text"
                                 formControlName="graduation_division_grade"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="graduation_certificate">Upload Your Graduation Certificate</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="graduation_certificate"
                                      (click)="fileUploadGraduationCertificate.click()"
                                      *ngIf="!docSubmittingGraduationCertificate"><i
                                class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <button class="btn btn-primary" *ngIf="docSubmittingGraduationCertificate">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i>Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'GRADUATION_CERTIFICATE')"
                                     #fileUploadGraduationCertificate>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileGraduationCertificate && fileGraduationCertificate.id && fileGraduationCertificate.url"
                                    (click)="goTo(fileGraduationCertificate.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i
                                  class="icofont icofont-cloud-upload font-size-20 mr-1"></i>
                                Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileGraduationCertificate && fileGraduationCertificate.id && fileGraduationCertificate.url"
                                    (click)="goTo(fileGraduationCertificate.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h6 class="mt-10">More Qualification - Post Graduation</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_university">University<small class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="post_graduation_university"
                                 formControlName="post_graduation_university" placeholder="Eg. Subharti University"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_course">Course<small class="text-danger">*</small></label>
                          <input class="form-control" id="post_graduation_course" type="text"
                                 formControlName="post_graduation_course" placeholder="Eg. MBA"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_year_of_passing">Year of Passing<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="post_graduation_year_of_passing" type="number"
                                 formControlName="post_graduation_year_of_passing"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_division_grade">Percentage / Grade / Division<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="post_graduation_division_grade" type="text"
                                 formControlName="post_graduation_division_grade"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_certificate">Upload Your Post Graduation Certificate</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="post_graduation_certificate"
                                      (click)="fileUploadPostGraduationCertificate.click()"
                                      *ngIf="!docSubmittingPostGraduationCertificate">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <button class="btn btn-primary"
                                      *ngIf="docSubmittingPostGraduationCertificate">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i>Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'POST_GRADUATION_CERTIFICATE')"
                                     #fileUploadPostGraduationCertificate>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePostGraduationCertificate && filePostGraduationCertificate.id && filePostGraduationCertificate.url"
                                    (click)="goTo(filePostGraduationCertificate.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="filePostGraduationCertificate && filePostGraduationCertificate.id && filePostGraduationCertificate.url"
                                    (click)="goTo(filePostGraduationCertificate.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h6 class="mt-10">More Qualification - Other Qualification</h6>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="other_qualification_university">University<small
                            class="text-danger">*</small></label>
                          <input class="form-control" type="text" id="other_qualification_university"
                                 formControlName="other_qualification_university"
                                 placeholder="Eg. Subharti University"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="other_qualification_course">Course<small class="text-danger">*</small></label>
                          <input class="form-control" id="other_qualification_course" type="text"
                                 formControlName="other_qualification_course" placeholder="Eg. MBA"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="other_qualification_year_of_passing">Year of Passing<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="other_qualification_year_of_passing" type="number"
                                 formControlName="other_qualification_year_of_passing"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="other_qualification_division_grade">Percentage / Grade / Division<small
                            class="text-danger">*</small></label>
                          <input class="form-control" id="other_qualification_division_grade" type="text"
                                 formControlName="other_qualification_division_grade"/>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                          <label for="post_graduation_certificate">Upload Your Other Qualification Certificate</label>
                          <div class="row" *ngIf="!submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-primary" id="other_qualification_certificate"
                                      (click)="fileUploadOtherQualificationCertificate.click()"
                                      *ngIf="!docSubmittingOtherQualificationCertificate">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <button class="btn btn-primary"
                                      *ngIf="docSubmittingOtherQualificationCertificate">
                                <i class="fas fa-spinner fa-pulse color-white mr-1"></i>Upload
                              </button>
                              <input class="form-control-file display-hidden"
                                     type="file"
                                     (change)="onFileChange($event, 'OTHER_QUALIFICATION_CERTIFICATE')"
                                     #fileUploadOtherQualificationCertificate>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileOtherQualificationCertificate && fileOtherQualificationCertificate.id && fileOtherQualificationCertificate.url"
                                    (click)="goTo(fileOtherQualificationCertificate.url)">View</span>
                            </div>
                          </div>
                          <div class="row" *ngIf="submittedForm">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <button class="btn btn-secondary">
                                <i class="icofont icofont-cloud-upload font-size-20 mr-1"></i>Upload
                              </button>
                              <span class="upload-btn-span-view cursor-pointer"
                                    *ngIf="fileOtherQualificationCertificate && fileOtherQualificationCertificate.id && fileOtherQualificationCertificate.url"
                                    (click)="goTo(fileOtherQualificationCertificate.url)">View</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary pull-right mt-10" type="submit" (click)="submitMoreQualifications()"
                        *ngIf="!submittedForm">
                  Save & Next
                </button>
                <button class="btn btn-primary pull-right mt-10" type="submit" (click)="wizard.goToNextStep()"
                        *ngIf="submittedForm">
                  Next
                </button>
                <button class="btn btn-secondary mt-10" type="button" awPreviousStep>Previous</button>
              </form>
            </aw-wizard-step>
            <aw-wizard-step [navigationSymbol]="{ symbol: '5' }">
              <form [formGroup]="courseDetailForm">
                <ng-template awWizardStepTitle>
                  <p class="d-lg-block d-sm-none">Course Details</p>
                </ng-template>
                <div class="setup-content mt-50" id="step-5">
                  <h5 class="d-lg-none d-sm-block text-center m-b-50">Course Details</h5>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label class="control-label">Program</label>
                      <select class="form-control mt-1" formControlName="program_id"
                              (change)="getCourses($event)">
                        <option value="">Select Program</option>
                        <option [value]="program.id" *ngFor="let program of programs">{{program?.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label class="control-label">Course</label>
                      <select class="form-control mt-1" formControlName="course_id" (change)="getBranches($event)">
                        <option value="">Select Course</option>
                        <option [value]="course['course'].id"
                                *ngFor="let course of courses">{{course?.course?.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12" *ngIf="branches && branches.length > 0">
                    <div class="form-group">
                      <label class="control-label">Branches</label>
                      <select class="form-control mt-1" formControlName="branch_id">
                        <option value="">Select Branch</option>
                        <option [value]="branch['branch'].id"
                                *ngFor="let branch of branches">{{branch?.branch?.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <button class="btn btn-primary pull-right mt-10" type="button" (click)="submitCourse()"
                            *ngIf="!submittedForm">Final Submit
                    </button>
                    <button class="btn btn-primary pull-right mt-10" type="submit" (click)="wizard.goToNextStep()"
                            *ngIf="submittedForm">
                      Next
                    </button>
                    <button class="btn btn-secondary mt-10" type="button" awPreviousStep>Previous</button>
                  </div>
                </div>
              </form>
            </aw-wizard-step>
            <aw-wizard-step [navigationSymbol]="{ symbol: '6' }" *ngIf="appliedBy === 'DIRECT'">
              <ng-template awWizardStepTitle>
                <p class="d-lg-block d-sm-none">Payment</p>
              </ng-template>
              <div class="setup-content mt-50" id="step-6">
                <h5 class="d-lg-none d-sm-block text-center m-b-50">Payment</h5>
                <div class="col-xs-12 text-center mb-10px">
                  <h5>Fee Structure - {{selectedPCBMapping?.course?.name}} <span
                    *ngIf="selectedPCBMapping && selectedPCBMapping['branch_id']">({{selectedPCBMapping?.branch?.name}}
                    )</span></h5>
                </div>
                <div class="col-xs-12">
                  <table class="table shadow-1px-light table-striped fee-structure-table">
                    <tr>
                      <td>
                        Registration Fee
                      </td>
                      <td *ngIf="studentData && studentData['registration_fee_status'] != 'COMPLETED'">
                        &#8377; {{this.courseCurriculumData?.registration_amount | IndianNumber}}
                      </td>
                      <td *ngIf="studentData && studentData['registration_fee_status'] == 'COMPLETED'">
                        &#8377; {{this.courseCurriculumData?.registration_amount | IndianNumber}}  <span class="text-success">(Paid)</span>
                        <i class="fa-solid fa-money-check font-size-20 cursor-pointer mt-1 ml-1 mr-5px text-success" title="Registration Fee Paid"
                         (click)=openUrl(studentData)></i>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Course Fee
                      </td>
                      <td>
                        &#8377; {{this.courseCurriculumData?.course_fee | IndianNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Prospectus Fee
                      </td>
                      <td>
                        &#8377; {{this.courseCurriculumData?.prospectus_fee | IndianNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Service Charge
                      </td>
                      <td>
                        &#8377; {{this.courseCurriculumData?.service_charge | IndianNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Examination Fee
                      </td>
                      <td>
                        &#8377; {{this.courseCurriculumData?.examination_fee | IndianNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total
                      </td>
                      <td *ngIf="studentData && studentData['registration_fee_status'] != 'COMPLETED'">
                        &#8377; {{this.courseCurriculumData?.total_fee | IndianNumber}}
                      </td>
                      <td *ngIf="studentData && studentData['registration_fee_status'] == 'COMPLETED'">
                        &#8377; {{this.courseCurriculumData?.total_fee_without_registration | IndianNumber}} &nbsp;
                        <i class="fa-solid fa-money-bills font-size-20 cursor-pointer mt-1 ml-1 mr-5px text-success" title="Complete Fee Paid"
                           (click)="openCompleteUrl(studentData)" *ngIf="studentData && studentData['complete_fee_status'] && (studentData['complete_fee_status'] === 'COMPLETED')"></i>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="col-xs-12 mt-10">
                  <button class="btn btn-success pull-right mt-10" type="button" (click)="payNow('COMPLETE_FEE')" *ngIf="studentData && studentData['complete_fee_status'] !== 'COMPLETED'">
                    Pay Complete Fee
                  </button>
                  <button class="btn btn-success btn-dark-grey pull-right mt-10" type="button" *ngIf="studentData && studentData['complete_fee_status'] === 'COMPLETED'">
                    Pay Complete Fee
                  </button>
                  <button class="btn btn-primary pull-right mt-10 mr-5px" type="button" (click)="payNow('REGISTRATION_FEE')" *ngIf="studentData && studentData['registration_fee_status'] !== 'COMPLETED' && studentData['complete_fee_status'] !== 'COMPLETED'">
                    Pay Registration Fee
                  </button>
                  <button class="btn btn-dark-grey pull-right mt-10 mr-5px" type="button" *ngIf="studentData && (studentData['registration_fee_status'] === 'COMPLETED' || studentData['complete_fee_status'] === 'COMPLETED')">
                    Pay Registration Fee
                  </button>
                  <button class="btn btn-secondary mt-10" type="button" awPreviousStep>Previous</button>
                </div>
              </div>
            </aw-wizard-step>
          </aw-wizard>
        </div>
      </div>
    </div>
  </div>
</div>
